"use client";

import { Coffee, Star, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowWeRank() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const steps = [{
    icon: Star,
    title: "Aggregate Reviews",
    description: "We collect and analyze ratings from Google Reviews and Yotpo to ensure authenticity and reliability.",
    ref: ref1,
    isVisible: isVisible1
  }, {
    icon: TrendingUp,
    title: "Score & Rank",
    description: "Each roaster is scored based on review volume, rating consistency, and customer sentiment across platforms.",
    ref: ref2,
    isVisible: isVisible2
  }, {
    icon: Coffee,
    title: "Curate & Present",
    description: "We showcase the top performers with detailed profiles, flavor notes, and direct purchase links for your convenience.",
    ref: ref3,
    isVisible: isVisible3
  }];
  return <section className="bg-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-5xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
            How We Rank
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Our transparent methodology ensures you discover only the finest specialty coffee roasters in Canada.
          </p>
        </div>

        <div className="space-y-12 md:space-y-16">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={i} data-index={i} ref={step.ref} className="flex flex-col items-center gap-6 md:flex-row md:gap-8">
                <div className={`group flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10 shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.01] hover:shadow-[0_0_20px_hsla(35,70%,45%,0.3)] md:h-24 md:w-24 ${step.isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
              transitionDelay: step.isVisible ? "0ms" : "0ms"
            }}>
                  <Icon className="h-10 w-10 text-primary transition-transform duration-[var(--duration-fast)] group-hover:scale-105 md:h-12 md:w-12" />
                </div>

                <div className="flex-1 text-center md:text-left">
                  <h3 className={`font-display text-2xl font-semibold text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] md:text-3xl ${step.isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
                transitionDelay: step.isVisible ? "150ms" : "0ms"
              }}>
                    {step.title}
                  </h3>
                  <p className={`mt-3 text-muted-foreground text-base leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] md:text-lg ${step.isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
                transitionDelay: step.isVisible ? "250ms" : "0ms"
              }}>
                    {step.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}